// extracted by mini-css-extract-plugin
export default {"centeredContainer":"About_centeredContainer__ZfnrR","styledParagraph":"About_styledParagraph__qHgHg","signatureImage":"About_signatureImage__-tOB-"};